
import Vue from 'vue';
import Lottie from '../Lottie.vue';
import * as desktopAnimation from '@/assets/animations/confetti-floating.json';
import * as tabletAnimation from '@/assets/animations/confetti-tablet-portrait.json';
import * as mobileAnimation from '@/assets/animations/confetti-floating-mobile.json';

export default Vue.extend({
  components: { Lottie },
  methods: {
    generateOptions(screenType: 'desktop' | 'tablet' | 'mobile') {
      const animationDataByScreenType = {
        desktop: desktopAnimation,
        tablet: tabletAnimation,
        mobile: mobileAnimation,
      };

      return {
        loop: false,
        autoplay: true,
        speed: 0.65,
        animationData: animationDataByScreenType[screenType],
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice',
        },
      };
    },
  },
});
